import { memo, useState, useCallback } from 'react';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Popover } from 'foundations-components/transitional/components/Popover';
import CampaignsPlatformLabelTag from './CampaignsPlatformLabelTag';
import CampaignsPlatformLabelPopover from './CampaignsPlatformLabelPopover';
import { Button } from 'foundations-components/transitional/components/Button';
import { getPropertyValue } from 'marketing-platform-lib/utils/crmUtils';
import { useFetchCampaignsPlatformLabelData } from './hooks/useFetchCampaignsPlatformLabelData';
import { popoverClickTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultHeaderComponent = ({
  children
}) => /*#__PURE__*/_jsx(Text, {
  typography: "heading-50",
  children: children
});
function CampaignsPlatformLabel({
  objectType,
  assetId,
  crmIdProperty = 'hs_object_id',
  HeaderComponent = DefaultHeaderComponent,
  as = 'tag',
  inline = false,
  withEmptyState = true
}) {
  const [open, setOpen] = useState(false);
  const handleOpenChange = useCallback(() => {
    if (!open) popoverClickTracker({
      objectType
    });
    setOpen(!open);
  }, [open, objectType]);
  const {
    hasAssociationSettings,
    associatedCampaign,
    loading
  } = useFetchCampaignsPlatformLabelData({
    objectType,
    assetId,
    crmIdProperty
  });
  if (loading || !hasAssociationSettings || !withEmptyState && !associatedCampaign) {
    return null;
  }
  return /*#__PURE__*/_jsxs(Flex, {
    flexDirection: inline ? 'row' : 'column',
    display: inline ? 'inline-flex' : 'flex',
    "data-test-id": "campaigns-platform-label",
    "data-test-inline": inline,
    children: [/*#__PURE__*/_jsx(HeaderComponent, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "campaignSelect.formControlLabel"
      })
    }), loading ? null : associatedCampaign ? /*#__PURE__*/_jsx(Popover, {
      open: open,
      onOpenChange: handleOpenChange,
      content: /*#__PURE__*/_jsx(CampaignsPlatformLabelPopover, {
        campaignCrmObject: associatedCampaign
      }),
      inlineSize: "360px",
      children: as === 'tag' ? /*#__PURE__*/_jsx(CampaignsPlatformLabelTag, {
        onClick: handleOpenChange,
        campaignCrmObject: associatedCampaign
      }) : /*#__PURE__*/_jsx(Button, {
        onClick: handleOpenChange,
        use: "link",
        children: getPropertyValue(associatedCampaign, 'hs_name')
      })
    }) : /*#__PURE__*/_jsx("span", {
      "data-test-id": "empty-campaigns-platform-label",
      children: "-"
    })]
  });
}
export default /*#__PURE__*/memo(CampaignsPlatformLabel);